export default __webpack_public_path__ + "static/1_8-45119a09d58da8cca0ed2f5c4459fc18.png";